import { SlideInPanelAnchorLocation } from "@redotech/redo-storefront-common/slide-in-panel-anchor-location";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { SlideInPanel } from "@redotech/redo-web/slide-in-panel";
import { Header, Text } from "@redotech/redo-web/text";
import { CSSProperties, memo, MouseEvent } from "react";

export interface RescuePanelContentProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description: string;
  buttonText: string;
  buttonSubtext?: string;
  placement: SlideInPanelAnchorLocation;
  buttonStyles: CSSProperties;
  buttonPending?: boolean;
  onButtonClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  readonlyPreview?: boolean;
  withDataTargets?: boolean;
}

export const RescuePanelContent = memo(function RescuePanelContent({
  open,
  onClose,
  title,
  description,
  buttonText,
  buttonSubtext,
  placement,
  buttonStyles,
  buttonPending = false,
  onButtonClick,
  readonlyPreview = false,
  withDataTargets = false,
}: RescuePanelContentProps) {
  return (
    <SlideInPanel
      anchorLocation={placement}
      closeButtonDataTarget={withDataTargets ? "rescue-panel-close" : undefined}
      dataTarget={withDataTargets ? "rescue-panel" : undefined}
      handleCloseClick={onClose}
      open={open}
      readonlyPreview={readonlyPreview}
    >
      <Flex align="flex-start" dir="column" gap="xl" w="full">
        <Flex align="flex-start" dir="column" gap="xl">
          <Header
            dataTarget={withDataTargets ? "rescue-panel-title" : undefined}
            fontSize="sm"
            fontWeight="bold"
            textColor="primary"
          >
            {title}
          </Header>
          <Text
            dataTarget={
              withDataTargets ? "rescue-panel-description" : undefined
            }
            fontSize="md"
            fontWeight="regular"
            textColor="primary"
          >
            {description}
          </Text>
        </Flex>

        <Flex dir="column" gap="md" w="full">
          <Flex align="center" gap="xl" w="full">
            <Flex flex={1}>
              <RedoButton
                dangerousStyleThatShouldOnlyBeUsedForMerchantBranding={
                  buttonStyles
                }
                dataTarget={withDataTargets ? "rescue-panel-button" : undefined}
                flexGrow={1}
                hierarchy="primary"
                onClick={onButtonClick}
                pending={buttonPending}
                size="xl"
                text={buttonText}
              />
            </Flex>
          </Flex>
          {buttonSubtext && (
            <Flex justify="center" w="full">
              <Text
                dataTarget={
                  withDataTargets ? "rescue-panel-subtext" : undefined
                }
                fontSize="xs"
                fontWeight="regular"
                textColor="secondary"
              >
                {buttonSubtext}
              </Text>
            </Flex>
          )}
        </Flex>
      </Flex>
    </SlideInPanel>
  );
});
